<div *ngIf="loading | async"
     class="loader">
  <p-progress-spinner />
</div>
